import { FC, ReactNode } from 'react'
import { RightFlag, usePermission } from '../../../auth'
import NotFound from '../NotFound'
import { NO_PERMISSION_MESSAGE } from './PermissionGate'

/** Full-screen state for pages/tabs the user may not open. */
export const AccessDenied: FC = () => (
  <NotFound notFoundTitle="Access denied" notFoundText={NO_PERMISSION_MESSAGE} />
)

type Props = {
  right: string
  flag?: RightFlag
  children: ReactNode
}

/** Renders children only when the user holds the right; otherwise AccessDenied. */
const RequirePermission: FC<Props> = ({ right, flag = 'view', children }) => {
  const { can } = usePermission()

  return can(right, flag) ? <>{children}</> : <AccessDenied />
}

export default RequirePermission
